module.exports = __webpack_public_path__ + "img/about-shape1.e71b4136.png";